module.exports = __webpack_public_path__ + "static/media/logo.9470e2d5.svg";